export const selectionTypes = {
    ORDERS: 'orders',
    STYLES: 'styles',
};

export const groupTypes = {
    LINES: 'lines',
    SECTIONS: 'sections',
};
